import { SquarePen, Trash2 } from "lucide-react";
import { useState } from "react";
import { updateMember } from "../../api/careTeamApi";

export default function ViewCareTeams({ careTeam, onDelete, fetchMembers, user_id }) {
  const [editingMember, setEditingMember] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUpdateMember = async () => {
    try {
      await updateMember(editingMember.id, {
        user_id: user_id,
        role: editingMember.role,
        name: editingMember.name,
        phone: editingMember.phone,
        fax: editingMember.fax,
        location: editingMember.location,
        hours: editingMember.hours
      });

      setIsModalOpen(false);
      fetchMembers();
    } catch (error) {
      console.error("Failed to update member: ", error);
    }
  }

  const handleEditClick = async (item) => {
    if (!item.id) {
      console.warn('Care team member ID missing', item);
      return;
    }

    setEditingMember(item);
    setIsModalOpen(true);
  }
  return (
    <div className="bg-white rounded-lg p-6 shadow">
      <h1 className="mb-6 text-3xl font-bold text-[#04395b]">Your Care Team</h1>
      <div className="mb-10 space-y-6">
        {careTeam.length === 0 ? (<p className="text-gray-500">No saved physicians found.</p>) :
          (<div className="space-y-3">
            {careTeam.map((member) => (
              <div
                key={member.id}
                className="p-4 bg-gray-100 rounded-lg border border-gray-300 shadow-md flex justify-between items-center"
              >

                <div>
                  <h2 className="text-xl font-semibold text-[#04395b]">{member.name}</h2>
                  <p className="text-sm text-gray-600 mb-2">{member.role}</p>
                  <div className="text-sm space-y-1">
                    <p><span className="font-medium">Phone: {member.phone || "N/A"}</span></p>
                    <p><span className="font-medium">Fax: {member.fax || "N/A"}</span></p>
                    <p><span className="font-medium">Location: {member.location || "N/A"}</span></p>
                    <p><span className="font-medium">Hours: {member.hours || "N/A"}</span></p>
                  </div>
                </div>

                <div className="flex gap-3 ml-6">
                  <button
                    onClick={() => handleEditClick(member)}
                    className="text-sm p-2 bg-[#04395b] text-white rounded hover:bg-[#021724]"
                  >
                    <SquarePen />
                  </button>
                  <button
                    onClick={() => onDelete(member.id)}
                    className="text-sm bg-gray-300 p-2 rounded hover:bg-gray-400"
                  >
                    <Trash2 />
                  </button>
                </div>
              </div>
            ))}

            {isModalOpen && editingMember && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                <div className="bg-white p-6 rounded shadow-lg w-[600px] space-y-4">
                  <h3 className="text-xl font-bold text-[#04395b] mb-2">Edit Care Team Member</h3>

                  <div className="grid grid-cols-2 gap-4">
                    {/* Role */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700">Role</label>
                      <input
                        type="text"
                        value={editingMember.role}
                        onChange={(e) => setEditingMember({ ...editingMember, role: e.target.value })}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>

                    {/* Name */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700">Name</label>
                      <input
                        type="text"
                        value={editingMember.name}
                        onChange={(e) => setEditingMember({ ...editingMember, name: e.target.value })}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700">Phone</label>
                      <input
                        type="text"
                        value={editingMember.phone}
                        onChange={(e) => setEditingMember({ ...editingMember, phone: e.target.value })}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>

                    {/* Fax */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700">Fax</label>
                      <input
                        type="text"
                        value={editingMember.fax}
                        onChange={(e) => setEditingMember({ ...editingMember, fax: e.target.value })}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>

                    {/* Location */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700">Location</label>
                      <input
                        type="text"
                        value={editingMember.location}
                        onChange={(e) => setEditingMember({ ...editingMember, location: e.target.value })}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>

                    {/* Hours */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700">Hours</label>
                      <input
                        type="text"
                        value={editingMember.hours}
                        onChange={(e) => setEditingMember({ ...editingMember, hours: e.target.value })}
                        className="w-full border px-3 py-2 rounded"
                      />
                    </div>
                  </div>

                  {/* Modal Buttons */}
                  <div className="flex justify-end space-x-2 pt-4">
                    <button
                      onClick={() => setIsModalOpen(false)}
                      className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleUpdateMember}
                      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}


          </div>)
        }
      </div>
    </div>
  )
}